import { Pipe, PipeTransform } from '@angular/core';
import { localizeFeedbackReason } from './chat-feedback-reasons';

/**
 * ENT-16247 — pure pipe wrapper around {@link localizeFeedbackReason}.
 *
 * Replaces the `reasonLabel(r)` template method call: a method binding is
 * re-evaluated on every change-detection pass, whereas a pure pipe memoises
 * its result per input value and only recomputes when the reason changes.
 */
@Pipe({
  name: 'feedbackReasonLabel',
  standalone: false
})
export class FeedbackReasonLabelPipe implements PipeTransform {
  transform(reason: string): string {
    return localizeFeedbackReason(reason);
  }
}
